export default __webpack_public_path__ + "menu-home-smop-icon.dbb798cac09d8e94ff7141f4c3b9c9e7.svg";